export const BASE_URL = process.env.REACT_APP_API_ENDPOINT;
export const ENV = process.env.REACT_APP_ENV;
export const APP_NAME = "Henkel Inventory Manager";
